import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";



export default function StockConfirmModal({open, setOpen, onConfirm, part}){



    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            onClose={() => setOpen(false)}
            closeOnBlur
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Confirm Stock Accrual Change</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onConfirm}
                                isFullWidth
                            >
                                Confirm
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={(e) => {e.stopPropagation(); setOpen(false);}}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );
}